import type { Maybe } from 'types/Utilities';

// TODO: ALUM - should this continue to exist after account-based routes are the norm?
/**
 * @param args - one or more args to be used in the route (e.g., account ID)
 * @returns Object with URLs to the AMUI routes for the given site
 */
export function accountBasedRoutes(...args: Array<Maybe<string | number>>) {
  const accountBase = `/account/${args[0]}`;

  return {
    /** `/account/:accountId` */
    account: accountBase,
    /** `/account/:accountId/agency` */
    agency: `${accountBase}/agency`,
    /** `/account/:accountId/agency/clients/create` */
    createClient: `${accountBase}/agency/clients/create`,
    /** `/account/:accountId/site/:siteId` */
    site: `${accountBase}/site/${args[1]}`,
    /** `/account/:accountId/call-tracking` */
    callTracking: `${accountBase}/call-tracking`,
    /** `/account/:accountId/call-tracking/details/call/:id` */
    callTrackingCallDetails: `${accountBase}/call-tracking/details/call/${args[1]}`,
    /** `/account/:accountId/call-tracking/details/text/:id` */
    callTrackingTextDetails: `${accountBase}/call-tracking/details/text/${args[1]}`,
    /** `/account/:accountId/call-tracking/numbers` */
    callTrackingNumbers: `${accountBase}/call-tracking/numbers`,
    /** `/account/:accountId/call-tracking/numbers/edit/:id` */
    callTrackingNumbersEdit: `${accountBase}/call-tracking/numbers/edit/${args[1]}`,
    /** `/account/:accountId/call-tracking/new` */
    callTrackingNew: `${accountBase}/call-tracking/new`,
    /** `/account/:accountId/call-tracking/new/:id/campaign-linking` */
    callTrackingNewCampaignLinking: `${accountBase}/call-tracking/new/${args[1]}/campaign-linking`,
    /** `/account/:accountId/call-tracking/new/:id/number-routing` */
    callTrackingNewNumberRouting: `${accountBase}/call-tracking/new/${args[1]}/number-routing`,
    /** `/account/:accountId/call-tracking/new/:id/complete` */
    callTrackingNewComplete: `${accountBase}/call-tracking/new/${args[1]}/complete`,
    /** `/account/:accountId/team-members` */
    teamMembers: `${accountBase}/team-members`,
    /** `/account/:accountId/team-members/accept` */
    teamMembersAccept: `${accountBase}/team-members/accept`,
    /** `/account/:accountId/team-members/invite` */
    teamMembersInvite: `${accountBase}/team-members/invite`,
    /** `/account/:accountId/team-members/edit/:team-member-id` */
    teamMembersEdit: `${accountBase}/team-members/edit/${args[1]}`,
    onboarding: {
      /** `/account/:accountId/onboarding/resume` */
      resume: `${accountBase}/onboarding/resume`,
      /** `/account/:accountId/onboarding/existing-site` */
      existingSite: `${accountBase}/onboarding/existing-site`,
      /** `/account/:accountId/onboarding/business-name` */
      businessName: `${accountBase}/onboarding/business-name`,
      /** `/account/:accountId/onboarding/marketing-budget` */
      marketingBudget: `${accountBase}/onboarding/marketing-budget`,
      /** `/account/:accountId/onboarding/owner-name` */
      ownerName: `${accountBase}/onboarding/owner-name`,
      /** `/account/:accountId/onboarding/site-name` */
      siteName: `${accountBase}/onboarding/site-name`,
      /** `/account/:accountId/onboarding/phone-number` */
      phoneNumber: `${accountBase}/onboarding/phone-number`,
      /** `/account/:accountId/onboarding/address` */
      address: `${accountBase}/onboarding/address`,
      /** `/account/:accountId/onboarding/service-areas` */
      serviceAreas: `${accountBase}/onboarding/service-areas`,
      /** `/account/:accountId/onboarding/mission` */
      mission: `${accountBase}/onboarding/mission`,
      /** `/account/:accountId/onboarding/origin-story` */
      originStory: `${accountBase}/onboarding/origin-story`,
      /** `/account/:accountId/onboarding/problem-solved` */
      problemSolved: `${accountBase}/onboarding/problem-solved`,
      /** `/account/:accountId/onboarding/unique-promise` */
      uniquePromise: `${accountBase}/onboarding/unique-promise`,
      /** `/account/:accountId/onboarding/ideal-client` */
      idealClient: `${accountBase}/onboarding/ideal-client`,
      /** `/account/:accountId/onboarding/success-stories` */
      successStories: `${accountBase}/onboarding/success-stories`,
      /** `/account/:accountId/onboarding/results` */
      results: `${accountBase}/onboarding/results`,
      /** `/account/:accountId/onboarding/credentials` */
      credentials: `${accountBase}/onboarding/credentials`,
      /** `/account/:accountId/onboarding/branding` */
      branding: `${accountBase}/onboarding/branding`,
      /** `/account/:accountId/onboarding/location-strategy` */
      locationStrategy: `${accountBase}/onboarding/location-strategy`,
      /** `/account/:accountId/onboarding/seo-strategy` */
      seoStrategy: `${accountBase}/onboarding/seo-strategy`,
      /** `/account/:accountId/onboarding/content-strategy` */
      contentStrategy: `${accountBase}/onboarding/content-strategy`,
      /** `/account/:accountId/onboarding/site-preview` */
      sitePreview: `${accountBase}/onboarding/site-preview`,
      /** `/account/:accountId/onboarding/complete` */
      complete: `${accountBase}/onboarding/complete`,
    },
  };
}
